exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper {\n  position: fixed;\n  top:0;bottom:0;left:0;right:0;\n  background-color: #003790;\n  overflow-y:scroll;\n  z-index:1112;\n}\n.closeViewBtn {\n  position: absolute;\n  top:5px;\n  right:5px;\n}\ndt {\n  font-weight: 100;\n}\ndd {\n  font-weight:600;\n}\nh3 {\n  font-weight: 100;\n}\n\n.history-card table {\n  font-size:.7rem;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/inventory/view.component.css
// module id = 443
// module chunks = 0